<script setup lang="ts">
import { GAME_TYPE } from "~/constants";

export interface TeamsInfoProps {
  team1Name?: string;
  team2Name?: string;
  team1Color?: string;
  team2Color?: string;
  team1LogoUrl?: string;
  team2LogoUrl?: string;
  title?: string;
  gameType?: TGameType;
}

const props = defineProps<TeamsInfoProps>();
const isOtherGameType = computed(() => props.gameType === GAME_TYPE.OTHER || Boolean(!props.team1Name && !props.team2Name));
</script>

<template>
  <div class="flex flex-col justify-center">
    <div v-if="isOtherGameType" class="text-main line-clamp-2 font-medium text-base">
      {{ props.title }}
    </div>
    <div v-if="props.team1Name" class="relative flex items-center">
      <BaseLogo
        class="absolute"
        :src="props.team1LogoUrl"
        :icon-background="props.team1Color"
        with-border
        with-hover
        no-background
        with-initials
        :title="team1Name"
        fit="contain"
      />
      <h2 class="text-main line-clamp-1 text-body-medium teamsInfo__teamName">
        {{ props.team1Name }}
      </h2>
    </div>
    <div v-if="props.team2Name" class="relative flex items-center mt-2">
      <BaseLogo
        class="absolute"
        :src="props.team2LogoUrl"
        :icon-background="props.team2Color"
        with-hover
        with-border
        no-background
        with-initials
        :title="team2Name"
        fit="contain"
      />
      <h2 class="text-main line-clamp-1 text-body-medium teamsInfo__teamName">
        {{ props.team2Name }}
      </h2>
    </div>
  </div>
</template>

<style lang="scss">
.teamsInfo__teamName {
  @apply ml-12 rtl:ml-0 rtl:mr-12;
}
</style>
